import { ChipVariant } from "Components/atoms/chip"

interface EmployeeType {
    id: string;
    name: string;
}

enum EMPLOYEE_TYPES {
    EMPLOYEE = 'Employee',
    CONSULTANT = 'Consultant',
    COOP = 'Coop',
    POTENTIAL_CONSULTANT = 'Potential Consultant'
}

// Types are DB rows, so anything seeded later falls through to the default.
const EMPLOYEE_TYPE_VARIANT: Record<string, ChipVariant> = {
    [EMPLOYEE_TYPES.EMPLOYEE]: 'success',
    [EMPLOYEE_TYPES.CONSULTANT]: 'info',
    [EMPLOYEE_TYPES.COOP]: 'warning',
    [EMPLOYEE_TYPES.POTENTIAL_CONSULTANT]: 'secondary',
}

export { EMPLOYEE_TYPES, EMPLOYEE_TYPE_VARIANT };
export type { EmployeeType };
